/**
 * Auswertung der Benachrichtigungs-Einstellungen im Browser.
 *
 * Nativ (iOS/Android) filtert das Backend den Push selbst. Im Browser gibt es
 * keinen nativen Push — dort ist der Toast das Gegenstueck. Damit "Push bei
 * neuen Nachrichten" auch im Web etwas bewirkt, gilt hier dieselbe Tabelle
 * wie in backend/src/utils/notificationPrefs.js (PUSH_PREF_BY_TYPE).
 * Bei Aenderungen beide Stellen pflegen.
 */

export const PUSH_PREF_BY_TYPE = {
  CHAT_MESSAGE: 'chatMessages',
  SESSION_REMINDER: 'sessionStarting',
  SESSION_START: 'sessionStarting',
  SESSION_CANCELLED: 'sessionStarting',
  SESSION_REJOIN_NUDGE: 'sessionStarting',
  NEW_PUBLIC_SESSION: 'publicSessions',
  CONNECTION_ACCEPTED: 'matchFound',
  AURA_UPDATE: 'auraEarned',
};

/**
 * Darf fuer diesen Typ ein Browser-Toast erscheinen?
 * Fail-open: Solange keine Settings geladen sind (null) oder der Typ nicht
 * gemappt ist, wird angezeigt. Die Defaults kommen bereits aufgeloest vom
 * Backend, deshalb reicht der Vergleich auf `!== false`.
 */
export const isToastAllowed = (settings, type) => {
  const key = PUSH_PREF_BY_TYPE[type];
  if (!key) return true;
  return settings?.push?.[key] !== false;
};

/**
 * Soll bei einem gezeigten Toast ein Ton abgespielt werden?
 */
export const isSoundEnabled = settings => settings?.inApp?.sound !== false;
